import { createSlice } from '@reduxjs/toolkit';
import { getProject } from 'ducks/project/operators';
import { Slices } from 'ducks/slices';
import { ProjectsAPI } from 'ducks/types/api-types';
import { NullableNumberInterface } from 'ducks/types/type-helpers';

export type ProjectState = NullableNumberInterface<ProjectsAPI>;

const initialState: ProjectState = {
  project_id: null,
  project_name: '',
  organization_id: null,
  organization_name: '',
  delete_container_on_exit: false,
  default_billing_identifier: '',
  aws_access_key_id_parameter_name: '',
  aws_secret_access_key_parameter_name: '',
  is_archived: false,
  description: '',
};

const projectSlice = createSlice({
  name: Slices.PROJECT,
  initialState,
  reducers: {
    clearProject: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProject.fulfilled, (_, { payload }) => {
        return payload;
      })
      .addCase(getProject.rejected, () => {
        return initialState;
      });
  },
});

export const { clearProject } = projectSlice.actions;

export default projectSlice.reducer;
